/** 客户记忆 § 分条与提案类型（对齐服务端 CustomerMemory::Entries） */

export const MEMORY_ENTRY_DELIMITER = "\n§\n";

export type MemoryOp =
  | { action: "add"; content: string; old_text?: string }
  | { action: "replace"; old_text: string; content: string }
  | { action: "remove"; old_text: string; content?: string };

export type MemoryProposeResult = {
  ops: MemoryOp[];
  proposed_summary: string;
  current_summary: string | null;
};

export function splitMemoryEntries(summary: string | null | undefined): string[] {
  const text = summary?.trim() ?? "";
  if (!text) return [];
  return text
    .split(/\n§\n/)
    .map((e) => e.trim())
    .filter(Boolean);
}

export function joinMemoryEntries(entries: string[]): string {
  return entries.map((e) => e.trim()).filter(Boolean).join(MEMORY_ENTRY_DELIMITER);
}

export function memoryOpLabel(op: MemoryOp): string {
  if (op.action === "add") return "新增";
  if (op.action === "replace") return "更新";
  return "删除";
}

export function memoryOpPreview(op: MemoryOp): string {
  if (op.action === "remove") return op.old_text;
  if (op.action === "replace") return op.content;
  return op.content;
}
